import ItemWrapper from "../ItemWrapper"
import ItemImage from "../ItemImage"
import ItemHeader from "../ItemHeader"

export default function SimonStyleItem({
  assembledItem,
  banned,
  setItemModalOpen,
  readOnly,
  menuItemParams,
}) {
  const handleClick = () => {
    if (!banned && typeof setItemModalOpen === "function")
      setItemModalOpen(true)
  }

  return (
    <ItemWrapper
      assembledItem={assembledItem}
      banned={banned}
      className={`border-2 border-[var(--order-items-card-border-color)] max-h-[110px] min-h-[110px] bg-[var(--order-items-card-bg-color)]  text-[var(--order-items-card-text-color)]   flex flex-row justify-between relative pointer transition-all hidden-content appear !w-[90%] m-auto`}
      onClick={handleClick}
    >
      <ItemHeader
        assembledItem={assembledItem}
        banned={banned}
        forceHideDesc={true}
        headerClass={"p-2 text-xl flex flex-col justify-between"}
        readOnly={readOnly}
        menuItemParams={menuItemParams}
      />
      <ItemImage assembledItem={assembledItem} />
    </ItemWrapper>
  )
}
